import { createContext, useContext, useEffect, useState } from "react";


const HyperlinkContext = createContext();

export const useHyperlink = () => {
    const context = useContext(HyperlinkContext);

    if(!context) {
        throw new Error('useHyperlink must be used within a HyperlinkProvider');
    }

    return context;
}


export const HyperlinkProvider = ({children}) => {
    const [hyperlinkFunctions, setHyperLinkFunctions] = useState(null);
    const [brandName, setBrandName] = useState('AngelAi');

    useEffect(() => {
        const loadHyperlinkFunctions = async () => {
            try {
                const hyperlinkPath = process.env.REACT_APP_HYPERLINK_PATH;
                if (!hyperlinkPath) throw new Error('REACT_APP_HYPERLINK_PATH not set');
                const response = await fetch(hyperlinkPath);
                const jsCode = await response.text();
                const func = new Function(jsCode+'; return {getHyperLink, addHyperlinks};');
                const functions = func();
                setHyperLinkFunctions(functions);
            } catch(error) {
                console.error('Error loading hyperlink functions:', error);
                try {
                    const config = await fetch(process.env.REACT_APP_ANGELAI_JSON);
                    const data = await config.json();
                    setBrandName(data.current.brandName || 'AngelAi');
                } catch(fallbackError) {
                    setBrandName('AngelAi');
                }
            }
        };
        loadHyperlinkFunctions();
    },[]);

    const getHyperLink = async (type,id,aliasIndex,target="_blank") => {
        if(hyperlinkFunctions){
            return await hyperlinkFunctions.getHyperLink(type, id , aliasIndex, target);
        }

        return brandName;
    }

    const addHyperlinks = async (text) => {
        if(hyperlinkFunctions) {
            return await hyperlinkFunctions.addHyperlinks(text);
        }

        return text;
    }

    return (
        <HyperlinkContext.Provider value={{getHyperLink,addHyperlinks,brandName}}>
            {children}
        </HyperlinkContext.Provider>
    );
};
